import { FeatureFlag } from "./FeatureFlags";

export const FLIPT_NAMESPACE = "default";

// Flipt is not live in production yet, so no flags may be Flipt-backed for this release.
// Keep this set empty until the go-live plan in docs/feature-flags.md is complete.
// Removed for release: REFER_A_FRIEND, PUBLIC_PROFILE, POKER_WEB_COMPONENT.
export const FLIPT_FLAGS: ReadonlySet<FeatureFlag> = new Set<FeatureFlag>([]);

export function isFliptFlag(flag: FeatureFlag): boolean {
  return FLIPT_FLAGS.has(flag);
}
